
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/page/[pageNum]",
      function () {
        return require("private-next-pages/well/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/page/[pageNum]"])
      });
    }
  